import React from 'react'
import firebase from 'firebase'

import swal from 'sweetalert'
import context from '../context';

const otherLogin = (via, setUser, props) => () => {
    firebase.auth().signInWithPopup(via).then(function(result) {
        setUser(result.user.uid, props)
      }).catch(function(error) {
        swal("Error", error.message, "error");
      })
}

const FormUser = (props) => {
  return (
    <div className="container mt-5">
  
      <div className="row pt-5">
          <div className="col-md-3"></div>
          <div className="col-md-6 text-center">
              <h2>{props.title}</h2>
              <hr/>
          </div>
      </div>

      <div className="row">
          <div className="col-md-3 field-label-responsive text-right pt-2">
              <label htmlFor="name">Email</label>
          </div>
          <div className="col-md-6">
              <div className="form-group">
                  <div className="input-group mb-2 mb-sm-0">
                      <input type="email" name="email" className="form-control" id="name" placeholder={ props.title === "Sign In" ? "" : "johndoe@mail.com" } onChange={props.changeState}/>
                  </div>
              </div>
          </div>
      </div>

      <div className="row">
          <div className="col-md-3 field-label-responsive text-right pt-2">
              <label htmlFor="password">Password</label>
          </div>
          <div className="col-md-6">
              <div className="form-group">
                  <div className="input-group mb-2 mb-sm-0">
                      <input type="password" name="password" className="form-control" id="password" placeholder={ props.title === "Sign In" ? "" : "Min length 6" } onChange={props.changeState}/>
                  </div>
              </div>
          </div>
      </div>

      <div className="row">
          <div className="col-lg">
              <div className="form-inline justify-content-center">
                <button type="submit" className="btn btn-success" onClick={props.action}>{ props.buttonName }</button>
              </div>
          </div>
      </div>


      <h6 className="text-center mt-2">Or</h6>
      <div className="row mt-3">
          <div className="col-lg">
              <div className="form-inline justify-content-center">
                    <context.Consumer>
                        {
                            data => {
                                return (
                                    <React.Fragment>
                                        <button className="loginBtn loginBtn--facebook" onClick={ otherLogin(new firebase.auth.FacebookAuthProvider(), data.setUser, props) }>
                                            { props.buttonName } with Facebook
                                        </button>

                                        <button className="loginBtn loginBtn--google" onClick={ otherLogin(new firebase.auth.GoogleAuthProvider(), data.setUser, props) }>
                                            { props.buttonName } with Google
                                        </button>
                                    </React.Fragment>
                                )
                            }
                        }
                    </context.Consumer>
              </div>
          </div>
      </div>

    </div>
  )
}

export default FormUser
